import {ActiveTrend} from "../../../../types/nbaTypes";
import {Box, Paper, Table, TableBody, TableCell, TableContainer, TableRow, Typography} from "@mui/material";
import {MyTrendsHeaders} from "./MyTrendsHeaders";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {EditTrendDialog} from "./EditTrendDialog";
import React, {useState} from "react";
import {useNavigate} from "react-router-dom";

export const TrendsTable =(
        {
            selectedTrend,
            trends,
            handleDelete,
            handleOpenEditDialog,
            handleNavigate,
            isEditDialogOpen,
        }:
        {
            selectedTrend?: ActiveTrend,
            trends: ActiveTrend[],
            handleDelete: (e: any, trend: ActiveTrend) => void,
            handleOpenEditDialog: (e: any, trend: ActiveTrend) => void,
            handleNavigate: (e: any, trend: ActiveTrend) => void,
            isEditDialogOpen: boolean,
        }
) => {

    const navigate = useNavigate()

    return (
        <TableContainer
            component={Paper}
            style={{
                maxWidth: '96%',
                marginLeft: 'auto',
                marginRight: 'auto',
                marginBottom: '40px',
            }}
        >
            <Table>
                <MyTrendsHeaders />
                <TableBody>
                    {trends?.map((trend: ActiveTrend, ind: number) => {
                        return (
                            <TableRow
                                sx={{
                                    '& > *': { paddingTop: '4px !important', paddingBottom: '4px !important'},
                                    '&:hover': {
                                        backgroundColor: 'lightgrey',
                                        cursor: 'pointer',
                                    },
                                }}
                                key={ind}
                                onClick={(e) => handleNavigate(e, trend)}
                            >
                                <TableCell>
                                    <Typography
                                        component="p"
                                        variant="caption"
                                        align="left"
                                    >
                                        {trend.sport.toUpperCase()}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography
                                        component="p"
                                        variant="caption"
                                        align="left"
                                    >
                                        {`${trend.atsWins} - ${trend.atsLosses}`}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography
                                        component="p"
                                        variant="caption"
                                        align="left"
                                    >
                                        {`${trend.overs} - ${trend.unders}`}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography
                                        component="p"
                                        variant="caption"
                                        align="left"
                                    >
                                        {`${trend.wins} - ${trend.losses}`}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography
                                        component="p"
                                        variant="caption"
                                        align="left"
                                    >
                                        {trend.trend}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography
                                        component="p"
                                        variant="caption"
                                        align="left"
                                    >
                                        {trend.trendDescription}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Box display="flex" justifyContent="space-between">
                                        <Typography display="flex" justifyContent="center" component="span" mr={1}>
                                            <DeleteIcon
                                                fontSize="small"
                                                onClick={(e) => handleDelete(e, trend)}
                                            />
                                        </Typography>
                                        <Typography display="flex" justifyContent="center" component="span" ml={1}>
                                            <EditIcon
                                                fontSize="small"
                                                onClick={(e) => handleOpenEditDialog(e,trend)}
                                            />
                                        </Typography>
                                    </Box>
                                </TableCell>
                            </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    )
}